// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React, { useRef, useState } from "react";
import Head from "next/head";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvButton, { IDtvButtonProps } from "@directv-digital/dds.ui.dtv-button";
import DtvGrid from "@directv-digital/dds.ui.dtv-grid";
import DtvText, { IDtvTextProps } from "@directv-digital/dds.ui.dtv-text";
import theme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import { Analytics, fireVideoPlayEvent, getAnalyticsAttrs } from '@directv-digital/dds.services.analytics-service';
import { useBreakPoints } from "@directv-digital/dds.utils";
import DynamicText, { DynamiceContentProps } from "@directv-digital/dds.ui.dynamic-text";

const MEDIA_ICONS: any = {
  PLAY: "https://www.directv.com/dtvassets/global/icons/2022/play_60px.svg",
  PAUSE: "https://www.directv.com/dtvassets/global/icons/2022/pause_60px.svg",
  MUTE: "https://www.directv.com/dtvassets/global/icons/2022/volume_off_60px.svg",
  UNMUTE:
    "https://www.directv.com/dtvassets/global/icons/2022/volume_on_60px.svg"
};
export type mode = "light" | "dark";

export interface IGradientProps {

  /**
  * CI configurable: Yes
  * DESC: To Configure the gradient
  */
  isGradient: boolean,
  /**
  * CI configurable: Yes
  * DESC: To Configure the starting point of gradient
  */
  startingFrom: string,
  /**
  * CI configurable: Yes
  * DESC: To Configure the color of first stop of gradient
  */
  color: string,
  /**
  * CI configurable: Yes
  * DESC: To Configure the color of second stop of gradient
  */
  secondaryColor: string,
  /**
  * CI configurable: Yes
  * DESC: To Configure the percentage of stop first of color
  */
  percentageFirst: string,
  /**
  * CI configurable: Yes
  * DESC: To Configure the percentage of stop of second color
  */
  percentageSecond: string,
  /**
  * CI configurable: Yes
  * DESC: To Configure the transparency of color in percentage
  */
  transparency: string,
}

interface _IsupportText {
  supText: IDtvTextProps,
  supportText?: any
}

export type AmbientVideoMarqueeProps = {
  /**
  * CI configurable: Yes
  * DESC: To update Component Id
  */
  id: string;
  /**
  * CI configurable: Yes
  * DESC: To get the different type of variant
  */
  variant?: string;
  /**
  * CI configurable: Yes
  * DESC: Select Button Dark or Light
  */
  // eslint-disable-next-line no-undef
  mode?: Mode;
  /**
  * CI configurable: Yes
  * DESC: Configure the title for showing the title content like Header.
  */
  title?: DynamiceContentProps;
  /**
  * CI configurable: Yes
  * DESC: Configure the description for showing the description content like subtitle or subheading. This is an Array
  */
  description?: any;
  /**
    * Configure the legalLink for showing the links content. Not CI configurable
    */
  legalLink?: string;
  /**
    * To Configure the background Color of the button cards
    */
  backgroundColor?: string;
  /**
   * CI configurable: Yes
   * DESC: To configure the Color of text
   */
  color?: string;

  /**
  * CI configurable: Yes
  * DESC: To configure the supportText for extra content need to add
  */
  cta?: IDtvButtonProps;
  /**
 * CI configurable: Yes
 * DESC: To configure the clickable text and open either new link or Modal or clickable link
 */
  optionalCta?: IDtvButtonProps;
  /**
* CI configurable: Yes
* DESC: Image is an object for each breakpoint inside this we can update url and alt
*/
  image?: ImageProps;
  /**
 * CI configurable: Yes
 * DESC: logoIcon is an object for each logo inside this we can update url and alt
 */
  logoIcon?: Image;
  /**
   * To add analytics for the component to track the user interaction
   */
  analytics?: Analytics;
  /**
 * CI configurable: Yes
 * DESC: To configure the price point introduction content
  */
  legalText?: DynamiceContentProps;
  /**
  * Configure the position of text for title and description
  */
  position?: string;
  /**
 * CI configurable: Yes
 * DESC: Configure the list Item text content for bullets
 */
  listItemText?: any[];
  /**
 * CI configurable: Yes
 * DESC: Configure the column value of listItemText
 */
  column?: string;
  /**
  * CI configurable: Yes
  * DESC: To configure the video on marquee background, if isVideo=true
 */
  video?: Video;
  /**
  * To configure the strike Text content
  */
  floatingImage?: Image;
  /**
  * Configure padding on top of copy area
  */
  paddingTop?: string;
  /**
  * Configure padding on bottom of copy area
  */
  paddingBottom?: string;
  /**
  * Gradient object support all Configurable values
  */
  gradient?: IGradientProps;
  /**
 * CI configurable: Yes
 * DESC: To configure the color of background
 */
  opacity?: IOpacityProps;
  /**
 * CI configurable: Yes
 * DESC: To make conditional rendering with the help of isExtended props.
  * */
  isExtended?: boolean;
  isFullWidth?: boolean;
  /**
   * To identify the Extra Large Desktop breakpoint
   */
  xl?: IMediaQuery;
  /**
* CI configurable: Yes
* DESC: To identify the Large Desktop breakpoint
*/
  lg?: IMediaQuery;
  /**
 * CI configurable: Yes
 * DESC: To identify the Desktop breakpoint
 */
  md?: IMediaQuery;
  /**
 * CI configurable: Yes
 * DESC: To identify the Tablet breakpoint
 */
  sm?: IMediaQuery;
  /**
 * CI configurable: Yes
 * DESC: To identify the Mobile breakpointoint
 */
  xs?: IMediaQuery;
  /**
 * CI configurable: Yes
 * DESC: To identify the tint color over the entire component
 */
  tint?: {
    color?: string;
    opacity?: number;
  }
};
interface IOpacityProps {
  /**
 * CI configurable: Yes
 * DESC: To configure the color of background (gradient default-#102641C3 | transparent)
 */
  color: string,
  opacity: string
}
interface Image {
  /**
 * CI configurable: Yes
 * DESC: To update image url
 */
  url?: string;
  /**
 * CI configurable: Yes
 * DESC: To update image alt text
 */
  alt?: string;
  /**
 * CI configurable: Yes
 * DESC: To check the corrosponding value is image or not
 */
  isImage?: ImageProps;
  /**
  * CI configurable: Yes
  * DESC: Configure the margin of image for title and description
  */
  margin?: string;
}
interface ImageProps {
  /**
 * CI configurable: Yes
 * DESC: To update image url for each breakpoint
 */
  url?: {
    sm: string;
    xs: string;
    md: string;
    lg: string;
    xl: string;
  };
  /**
  * CI configurable: Yes
  * DESC: To update image alt text for each breakpoint
  */
  alt?: string;
  /**
 * CI configurable: Yes
 * DESC: To check the corresponding value is image or not
 */
  isImage?: boolean;
  /**
 * CI configurable: Yes
 * DESC: Configure the margin of image for title and description
 */
  margin?: string;
}
interface Video {
  /**
  * CI configurable: Yes
  * DESC: To update image url for each breakpoint
  */
  url?: string;
  /**
 * CI configurable: Yes
 * DESC: To update image alt text for each breakpoint
 */
  alt?: string;
  /**
  * CI configurable: Yes
  * DESC: To Configure the poster image for videos
  */
  posterImg?: string;
  /**
  * CI configurable: Yes
  * DESC: To Configure the poster image Title  for videos
  */
  posterImgAlt?: string;
  /**
 * CI configurable: Yes
 * DESC: To Configure and check the sounds percpective for videos
 */
  hasSound?: boolean;
  /**
  * CI configurable: Yes
  * DESC: To check the data we are getting that is video type or not
  */
  isVideo?: boolean;
  /**
  * CI configurable: Yes
  * DESC: To show the content name of the video
  */
  contentFriendlyVideoName?: string;
  /**
  * CI configurable: Yes
  * DESC: URL to a WebVTT captions file (.vtt) for accessibility (WCAG 1.2.2)
  */
  captionsVtt?: string;
}

export interface IMediaQuery {
  /**
  * CI configurable: Yes
  * DESC: To configure the minimum height of ambient-video
  */
  minHeight: string,
  /**
  * CI configurable: Yes
  * DESC: To configure the background color of the marquee
  */
  backgroundColor: string,

  /**
  * CI configurable: Yes
  * DESC: To configure the padding top of the marquee
  */
  paddingTop: string,
  /**
 * CI configurable: Yes
 * DESC: To configure the padding bottom of the marquee
 */
  paddingBottom: string,
  /**
* CI configurable: Yes
* DESC: To configure the position of text (textAlign and alignItems property)
*/
  position?: any,
  /**
* CI configurable: Yes
* DESC: To configure the image specs like url or alt
*/
  image: Image,
  /**
 * CI configurable: Yes
 * DESC: To configure the video specs like url or alt
 */
  video: Video,
  /**
 * CI configurable: Yes
 * DESC: To configure the image is floating or not
 */
  floatingImage?: Image,
  /**
* CI configurable: Yes
* DESC: To configure the maxium width of ambient-video
*/
  justifyContent?: string,
  margin?: string,
  display?: string,
  maxWidth?: {
    xs: string,
    sm: string,
    md: string
  }
}

export function AmbientVideoMarquee(props: AmbientVideoMarqueeProps) {
  try {
    const { isMobile, isTablet, isDesktop: isDesktopOnly, isLargeDesktop, isXLDesktop } = useBreakPoints({ xlDesktop: 1920 });
    const isDesktop = isDesktopOnly || isLargeDesktop || isXLDesktop;
    const isExtended = props?.isExtended;
    const isImage = props?.image?.isImage;
    const isGradient = props?.gradient?.isGradient;
    const videoRef: any = useRef({});
    const [isVideoPaused, setVideoPaused] = useState(false);
    const [isVideoMuted, setVideoMuted] = useState(true);
    const [isMetaDataLoaded, setMetaDataLoaded] = useState(false);
    const [isAutoPlayTriggered, setAutoPlayTriggered] = useState(false);

    // Select the appropriate video URL based on current breakpoint
    const currentVideoUrl = React.useMemo(() => {
      // Priority order: most specific to least specific
      if (isXLDesktop && props?.xl?.video?.url) {
        return props.xl.video.url;
      }
      if (isLargeDesktop && props?.lg?.video?.url) {
        return props.lg.video.url;
      }
      if (isDesktop && props?.md?.video?.url) {
        return props.md.video.url;
      }
      if (isTablet && props?.sm?.video?.url) {
        return props.sm.video.url;
      }
      if (isMobile && props?.xs?.video?.url) {
        return props.xs.video.url;
      }

      // Fallback: first available video
      return (
        props?.md?.video?.url ||
        props?.sm?.video?.url ||
        props?.xs?.video?.url ||
        props?.lg?.video?.url ||
        props?.xl?.video?.url
      );
    }, [isMobile, isTablet, isDesktop, isLargeDesktop, isXLDesktop, props?.xs?.video?.url, props?.sm?.video?.url, props?.md?.video?.url, props?.lg?.video?.url, props?.xl?.video?.url]);

    const currentVideoPosterUrl = React.useMemo(() => {
      // Priority order: most specific to least specific
      if (isXLDesktop && props?.xl?.video?.posterImg) {
        return props.xl.video.posterImg;
      }
      if (isLargeDesktop && props?.lg?.video?.posterImg) {
        return props.lg.video.posterImg;
      }
      if (isDesktop && props?.md?.video?.posterImg) {
        return props.md.video.posterImg;
      }
      if (isTablet && props?.sm?.video?.posterImg) {
        return props.sm.video.posterImg;
      }
      if (isMobile && props?.xs?.video?.posterImg) {
        return props.xs.video.uposterImgrl;
      }

      // Fallback: first available video
      return (
        props?.md?.video?.posterImg ||
        props?.sm?.video?.posterImg ||
        props?.xs?.video?.posterImg ||
        props?.lg?.video?.posterImg ||
        props?.xl?.video?.posterImg
      );
    }, [isMobile, isTablet, isDesktop, isLargeDesktop, isXLDesktop, props?.xs?.video?.posterImg, props?.sm?.video?.posterImg, props?.md?.video?.posterImg, props?.lg?.video?.posterImg, props?.xl?.video?.posterImg]);

    const currentEnvironment = (): string => {
      if (typeof window !== "undefined") {
        const host = window.location.origin;
        // checking host fron https to exclude false matches
        if (host.includes("https://www.")) {
          return "prod";
        } else if (host.includes("https://stage.") || host.includes("https://finalstage.")) {
          return "prod";
        }
        return "prod";
      }
      return "prod";
    }

    const _findUrlType = url => {
      const imgExten = ['.jpeg', '.png', '.jpg', '.gif', '.bmp', '.webp', '.tiff']
      if (url) {
        return imgExten.some(extension => url.toLowerCase().endsWith(extension)) ? "image" : "video"
      }
      return false;
    }

    const getResponsiveGradient = (gradient, isMobile, isTablet, isDesktop) => {
      if (!gradient?.isGradient) {
        return "none";
      }
      let gProps = null;
      if (isMobile) {
        gProps = gradient.xs;
      } else if (isTablet) {
        gProps = gradient.sm;
      } else if (isDesktop) {
        gProps = gradient.md;
      }
      if (!gProps) {
        gProps = gradient.lg || gradient.md || gradient.sm || gradient.xs;
      }
      if (!gProps) {
        return "none";
      }
      return `linear-gradient(${gProps.startingFrom}, ${gProps.color} ${gProps.percentageFirst}, ${gProps.secondaryColor} ${gProps.percentageSecond}, transparent ${gProps.transparency})`;
    }
    // Memoize gradient calculation to prevent recalculation on every render
    const gradient = React.useMemo(
      () => getResponsiveGradient(props?.gradient, isMobile, isTablet, isDesktop),
      [props?.gradient, isMobile, isTablet, isDesktop]
    );
    const styles = {
      marqVideoContainer: {
        minHeight: {
          sm: "668px",
          md: props?.md?.minHeight,
          lg: props?.lg?.minHeight,
          xl: props?.xl?.minHeight
        },
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        zIndex: 1,
        background: gradient,
        overflow: "hidden"
      }
    }
    React.useEffect(() => {
      const vid = videoRef.current;
      if (vid && vid.readyState >= 3) {
        setMetaDataLoaded(true);
      }
    }, []);

    const handleResize = React.useCallback(() => {
      const cta = document?.getElementById(`${props?.id}-primaryCta`)
      const optCta = document?.getElementById(`${props?.id}-optionalCta`)

      if (cta !== null && optCta !== null && props?.video?.url) {
        if (window.innerWidth > theme.breakpoints.values.sm) {
          cta.style.marginRight = "32px";
          const _diff = cta.offsetWidth - optCta.offsetWidth;
        } else {
          cta.style.marginRight = "0";
          cta.style.width = "auto";
          optCta.style.width = "auto";
        }
      }
    }, [props?.id, props?.video?.url]);

    React.useEffect(() => {
      window?.addEventListener("resize", handleResize);
      window?.addEventListener("load", handleResize);

      // Cleanup event listeners to prevent memory leaks
      return () => {
        window?.removeEventListener("resize", handleResize);
        window?.removeEventListener("load", handleResize);
      };
    }, [handleResize]);

    const handleVideo = () => {
      setVideoPaused(prevPaused => {
        const nextPaused = !prevPaused;
        const activeVideoUrl = videoRef?.current?.currentSrc;
        if (!nextPaused) {
          fireVideoPlayEvent({
            event_name: "video_commence",
            video_status: "play",
            video_id: activeVideoUrl,
            video_name: props?.video?.contentFriendlyVideoName || "Tangerine Ambient video",
            video_length_total: Math.round(videoRef?.current?.duration),
            video_length_viewed: Math.round(videoRef?.current?.currentTime)
          });
          videoRef?.current?.play?.();
        } else {
          fireVideoPlayEvent({
            event_name: "video_update",
            video_status: "pause",
            video_id: activeVideoUrl,
            video_name: props?.video?.contentFriendlyVideoName || "Tangerine Ambient video",
            video_length_total: Math.round(videoRef?.current?.duration),
            video_length_viewed: Math.round(videoRef?.current?.currentTime)
          });
          videoRef?.current?.pause?.();
        }
        return nextPaused;
      });
    };
    const handleKeyDown = event => {
      if (event.key === "Enter") {
        handleVideo();
      }
    };
    const handleVideoAudio = () => {
      setVideoMuted(!isVideoMuted);
      videoRef.current.muted = isVideoMuted;
    };
    const handleKeyDownAudio = event => {
      if (event.key === "Enter") {
        handleVideoAudio();
      }
    };
    const handleMetadata = () => {
      setMetaDataLoaded(true);
      const activeVideoUrl = videoRef?.current?.currentSrc;
      if (isAutoPlayTriggered) {
        fireVideoPlayEvent({
          event_name: "video_commence",
          video_status: "auto",
          video_name: props?.video?.contentFriendlyVideoName || "Tangerine Ambient video",
          video_id: activeVideoUrl,
          video_length_total: Math.round(videoRef?.current?.duration),
          video_length_viewed: Math.round(videoRef?.current?.currentTime)
        });
      }
      setAutoPlayTriggered(false);
    };
    const currentTint = isMobile ?
      props?.tint?.xs :
      isTablet ?
        props?.tint?.sm :
        isDesktop ?
          props?.tint?.md :
          props?.tint?.lg;
    const renderVideo = poster => {
      const scriptArray = Array.isArray(props?.script) ? props?.script : [props?.script];
      const _posterImg = isMobile ?
        props?.xs?.video?.posterImg :
        isTablet ?
          props?.sm?.video?.posterImg :
          isDesktop ?
            props?.md?.video?.posterImg :
            props?.md?.video?.posterImg;
      return (
        <DtvGrid sx={{
 width: "100%",
height: "100%"
}}>
          <DtvBox
            sx={{
              position: "absolute",
              inset: 0
            }}
          >
            <Head>
              {/* LCP optimization: Prioritize poster if available, otherwise prioritize video */}
              {currentVideoPosterUrl ? (
                // Poster exists → it's the LCP, so preload with high priority
                <link
                  as="image"
                  fetchPriority="high"
                  href={`${currentVideoPosterUrl?.trim()}?noretina=true`}
                  rel="preload"
                />
              ) : (
                // No poster → video first frame is LCP, so preload video with high priority
                currentVideoUrl && (
                  <link
                    as="video"
                    fetchPriority="high"
                    href={currentVideoUrl}
                    rel="preload"
                  />
                )
              )}
            </Head>
            {currentVideoUrl ? (
              <video
                autoPlay
                playsInline
                aria-hidden="true"
                controls={false}
                id={`${props?.id}-video`}
                loop={true}
                muted={isVideoMuted}
                poster={currentVideoPosterUrl ? `${currentVideoPosterUrl.trim()  }?noretina=true` : undefined}
                preload="metadata"
                ref={videoRef}
                style={{
                  objectFit: "contain",
                  objectPosition: "top center",
                  width: "100%",
                  height: "auto",
                  zIndex: 0
                }}
                onPause={() => setVideoPaused(true)}
                onCanPlay={() => {
                  setMetaDataLoaded(true);
                }}
                onLoadedData={() => {
                  setMetaDataLoaded(true);
                  setAutoPlayTriggered(true);
                }}
                onPlay={e => {
                  setVideoPaused(false);
                  handleMetadata(e);
                }}
              >
                {/* Dynamically load only the video for current breakpoint */}
                <source src={currentVideoUrl} type="video/mp4" />
                {/* WCAG 1.2.2: Provide synchronized captions for deaf or hard-of-hearing users */}
                {props?.video?.captionsVtt && (
                  <track default kind="captions" label="English" src={props.video.captionsVtt} srcLang="en" />
                )}
              </video>
            ) : <>
              {currentEnvironment() !== "prod" ?
                <div style={{
 backgroundColor: "red",
color: "white",
padding: "12%",
fontSize: "30px",
textAlign: "center",
lineHeight: "120%",
fontWeight: "bold"
}}>
                  NON PROD ONLY: YOU ARE USING A VIDEO COMPONENT TO RENDER AN IMAGE, PLEASE FIX
                </div>                :
                // eslint-disable-next-line jsx-a11y/alt-text
                <img
                  id={`${props?.id}-image`}
                  src={props?.video?.posterImg}
                  style={{
                    // eslint-disable-next-line eqeqeq
                    width: (isMobile && !isGradient || !isGradient || (!isMobile && (props?.gradient?.startingFrom == "to right" || props?.gradient?.startingFrom == "to left"))) ? "auto" : "100%",
                    height: "100%"
                  }}
                >
                </img>
              }

            </>}

            {isMetaDataLoaded && (
              <>
                <DtvGrid
                  container
                  direction="column"
                  sx={{
                    position: "absolute",
                    top: {
                      xs: "15px",
                      sm: "623px",
                      md: "633px",
                      lg: "755px",
                      xl: "843px"
                    },
                    right: {
 xs: "20px",
lg: "32px",
xl: "140px"
},
                    gap: "16px",
                    zIndex: 997,
                    ...props?.video?.sx
                  }}
                >
                  {/* Row for Pause/Play and Mute/Unmute Icons */}
                  <DtvGrid
                    item
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: "16px"
                    }}
                  >
                    {/* Mute/Unmute Icon */}
                    <DtvBox
                      role="button"
                      tabIndex={0}
                      sx={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer"
                      }}
                      onClick={handleVideoAudio}
                      onKeyDown={handleKeyDownAudio}
                    >
                      {isVideoMuted ? (
                        <img
                          alt="mute"
                          aria-label="Mute button"
                          height="20px"
                          src={MEDIA_ICONS.MUTE}
                          width="20px"
                        />
                      ) : (
                        <img
                          alt="unmute"
                          aria-label="Unmute button"
                          height="20px"
                          src={MEDIA_ICONS.UNMUTE}
                          width="20px"
                        />
                      )}
                    </DtvBox>

                    {/* Play/Pause Icon */}
                    <DtvBox
                      role="button"
                      tabIndex={0}
                      sx={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer"
                      }}
                      onClick={handleVideo}
                      onKeyDown={handleKeyDown}
                    >
                      {isVideoPaused ? (
                        <img
                          alt="play"
                          aria-label="Play button"
                          height="20px"
                          src={MEDIA_ICONS.PLAY}
                          width="20px"
                        />
                      ) : (
                        <img
                          alt="pause"
                          aria-label="Pause button"
                          height="20px"
                          src={MEDIA_ICONS.PAUSE}
                          width="20px"
                        />
                      )}
                    </DtvBox>
                  </DtvGrid>
                </DtvGrid>
                {scriptArray.length > 0 ? (
                  scriptArray.map((script, index) => (
                      <script key={index} type={script.type}>
                        {script.value}
                      </script>
                    ))
                ) : (
                  null
                )}
              </>
            )}
          </DtvBox>
        </DtvGrid>
      )
    }
    const getTextBoxComponentType = (items: any) => {
      let componentType = "div";
      if (items?.component) {
        componentType = items?.component;
      } else {
        if (items?.variant === "h2") {
          componentType = "h2";
        } else {
          componentType = items?.variant;
        }
      }
      return componentType;
    }

    // Memoize description array to prevent recalculation on every render
    const descriptionArray = React.useMemo(
      () => (Array.isArray(props?.description) ? props?.description : [props?.description]),
      [props?.description]
    );

    // eslint-disable-next-line complexity
    const showVideo = () => {
      try {
        const poster = props?.video?.posterImg ?
          { poster: `${props.video.posterImg?.trim()  }?noretina=true` } :
          {};
        return (
          <DtvGrid
            container={true}
            direction="row"
            flexDirection="column"
            id={props?.id}
            position="relative"
            sx={{
              color:
                // eslint-disable-next-line eqeqeq
                props?.mode == "dark" ?
                  `${colorPalette.white.main}` :
                  `${colorPalette.jet.main}`,
              backgroundColor: props?.gradient?.color || "#000000",
              alignItems: "center"
            }}
          >
            {!isExtended && (props?.video?.isVideo || props?.video?.posterImg) && (
              renderVideo(poster)
            )}
            <DtvGrid
              container={true}
              direction="row"
              flexDirection="column"
              textAlign={isMobile ? "center" : isTablet ? props?.sm?.position : isDesktop && props?.md?.position}
              sx={{
                ...(props?.video?.isVideo && !isExtended ? {
                  ...styles.marqVideoContainer
                } : {
                  zIndex: 0,
                  ...((!isImage || isExtended) && {
                    background: {
                      xs: props?.xs?.backgroundColor,
                      sm: props?.sm?.backgroundColor,
                      md: props?.md?.backgroundColor,
                      lg: props?.lg?.backgroundColor,
                      xl: props?.xl?.backgroundColor
                    }
                  }),
                  minHeight: {
                    xs: props?.xs?.minHeight,
                    sm: props?.sm?.minHeight,
                    md: props?.md?.minHeight,
                    lg: props?.lg?.minHeight,
                    xl: props?.xl?.minHeight
                  }
                }
                )
              }}
            >
              {currentTint && (
                <DtvBox
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: currentTint?.background,
                    opacity: currentTint?.opacity,
                    pointerEvents: "none",
                    zIndex: 2
                  }}
                ></DtvBox>
              )}
              <DtvGrid
                container={true}
                direction="row"
                flexDirection="column"
                sx={{
                  alignItems: {
                    xs: props?.xs?.position === "left" ? "flex-start" : props?.xs?.position,
                    sm: props?.sm?.position === "left" ? "flex-start" : props?.sm?.position,
                    md: props?.md?.position === "left" ? "flex-start" : props?.md?.position
                  },
                  zIndex: 3,
                  textAlign: {
                    xs: props?.xs?.position,
                    sm: props?.sm?.position,
                    md: props?.md?.position
                  },
                  pt: {
                    xs: props?.xs?.paddingTop,
                    sm: props?.sm?.paddingTop,
                    md: props?.md?.paddingTop,
                    lg: props?.lg?.paddingTop,
                    xl: props?.xl?.paddingTop
                  },
                  pb: {
                    xs: props?.xs?.paddingBottom,
                    sm: props?.sm?.paddingBottom,
                    md: props?.md?.paddingBottom,
                    lg: props?.lg?.paddingBottom,
                    xl: props?.xl?.paddingBottom
                  }
                }}
              >
                {props?.eyebrow?.content && (
                  <DtvGrid
                    item
                    lg={4}
                    md={4}
                    sm={8}
                    xl={4}
                    xs={12}
                    sx={{
                      mb: props?.eyebrow?.mb || {
                        xs: "8px"
                      },
                      mx: {
                        xs: "20px",
                        sm: "32px",
                        md: "0px 32px 0px 32px",
                        lg: "32px",
                        xl: "140px"
                      },
                      ...props?.eyebrow?.sx
                    }}
                  >
                    <DtvText
                      aria-label={props?.eyebrow?.content}
                      component={props?.eyebrow?.component || "div"}
                      content={props?.eyebrow?.content}
                      id={`${props?.id}-eyebrow`}
                      variant={props?.eyebrow?.variant}
                      sx={{
                        color: props?.eyebrow?.color,
                        textDecoration: "none",
                        fontSize: props?.eyebrow?.fontSize || {
 xs: "15px",
md: "16px"
},
                        fontWeight: props?.eyebrow?.fontWeight || 700,
                        letterSpacing: props?.eyebrow?.letterSpacing || "0.45px"
                      }}
                    />
                  </DtvGrid>
                )}
                {props?.title?.content && (
                  <DtvGrid
                    item
                    // eslint-disable-next-line eqeqeq
                    lg={props?.md?.position == "left" ? 6 : 8}
                    // eslint-disable-next-line eqeqeq
                    md={props?.md?.position == "left" ? 6 : 8}
                    // eslint-disable-next-line eqeqeq
                    sm={props?.sm?.position == "left" ? 7 : 8}
                    // eslint-disable-next-line eqeqeq
                    xl={props?.md?.position == "left" ? 6 : 8}
                    xs={12}
                    sx={{
                      margin: props?.title?.margin || {
                        xs: "0px 20px 20px",
                        sm: "0px 32px 20px",
                        md: "0px 32px 0px 32px",
                        lg: "0px 32px 20px 32px",
                        xl: "0px 140px 20px 140px"
                      },
                      ...props?.title?.sx
                    }}
                  >
                    <div role="alert">
                      <DynamicText
                        color={props?.title?.color}
                        component={getTextBoxComponentType(props?.title)}
                        content={props?.title?.content}
                        dynamicContent={props?.title?.dynamicContent}
                        id={`${props?.id}-title`}
                        variant={props?.title?.variant}
                        sx={{
                          fontSize: {
 xs: "32px",
sm: "48px",
lg: "64px"
},
                          fontWeight: props?.title?.fontWeight || 500
                        }}
                      />
                    </div>
                  </DtvGrid>
                )}
                {props?.subheading?.content && (
                  <DtvGrid
                    item
                    // eslint-disable-next-line eqeqeq
                    lg={props?.md?.position == "left" ? 6 : 8}
                    // eslint-disable-next-line eqeqeq
                    md={props?.md?.position == "left" ? 6 : 8}
                    // eslint-disable-next-line eqeqeq
                    sm={props?.sm?.position == "left" ? 7 : 8}
                    // eslint-disable-next-line eqeqeq
                    xl={props?.md?.position == "left" ? 6 : 8}
                    xs={12}
                    sx={{
                      margin: {
                        xs: "0px 20px 20px",
                        sm: "0px 32px 20px",
                        md: "0px 32px 0px 32px",
                        lg: "0px 32px 20px 32px",
                        xl: "0px 140px 20px 140px"
                      },
                      ...props?.subheading?.sx
                    }}
                  >
                    <div role="alert">
                      <DynamicText
                        color={props?.subheading?.color}
                        component={getTextBoxComponentType(props?.subheading)}
                        content={props?.subheading?.content}
                        dynamicContent={props?.subheading?.dynamicContent}
                        id={`${props?.id}-subheading`}
                        variant={props?.subheading?.variant}
                        sx={{
                          fontSize: {
 xs: "20px",
md: "24px",
xl: "46px"
},
                          fontWeight: 400,
                          letterSpacing: "-0.4px",
                          ...props?.subheading?.sx
                        }}
                      />
                    </div>
                  </DtvGrid>
                )}

                {descriptionArray?.map((item, index) => (
                  item?.content &&
                  <DtvGrid
                    item
                    key={index}
                    // eslint-disable-next-line eqeqeq
                    lg={props?.md?.position == "left" || props?.floatingImage?.isFloatingImage ? 5 : 8}
                    // eslint-disable-next-line eqeqeq
                    md={props?.md?.position == "left" || props?.floatingImage?.isFloatingImage ? 5 : 8}
                    // eslint-disable-next-line eqeqeq
                    sm={props?.sm?.position == "left" ? 6 : 8}
                    // eslint-disable-next-line eqeqeq
                    xl={props?.md?.position == "left" || props?.floatingImage?.isFloatingImage ? 5 : 8}
                    xs={12}
                    sx={{
                      textAlign: props?.floatingImage?.isFloatingImage ? 'left' : "auto",
                      mb: (props?.pricePoint || isExtended) && "20px",
                      margin: props?.margin || {
                        xs: "0px 20px",
                        sm: "0px 32px",
                        md: "24px 32px 0px 32px",
                        lg: "0px 32px 0px 32px",
                        xl: "0px 140px 0px 140px",
                        ...props?.sx
                      }

                    }}
                  >
                    <div role="alert">
                      <DynamicText
                        color={item?.color}
                        component={props?.description?.component || "div"}
                        content={item?.content}
                        dynamicContent={item?.dynamicContent}
                        fontWeight={item?.fontWeight}
                        id={`${props?.id}-description-${index}`}
                        variant={item?.variant}
                        sx={{
 fontSize: props?.fontSize || {
 xs: "16px",
md: "20px"
}
}}
                      />
                    </div>
                  </DtvGrid>
                ))}
                {(props?.cta?.label || props?.optionalCta?.label) && (
                  <DtvGrid
                    item
                    md={props?.optionalCta?.label ? 12 : 6}
                    sm={props?.optionalCta?.label ? 12 : 6}
                    xs={12}
                    sx={{
                      mt: {
 xs: "32px",
sm: "32px"
},
                      mb: {
 xs: "20px",
sm: "32px"
},
                      width: {
 xs: "100%",
sm: "auto"
},
                      px: {
                        xs: "20px",
                        sm: "32px",
                        md: "0px 32px 0px 32px",
                        lg: "32px",
                        xl: "140px"
                      },
                      ...props?.cta?.sx
                    }}
                  >
                    <DtvBox id={`${props.id}-dual_cta_container`}>
                      {props?.cta?.label && (
                        <DtvButton
                          id={`${props?.id}-primaryCta`}
                          label={props?.cta?.label}
                          variant={props?.cta?.variant}
                          sx={{
                            mb: {
 xs: "24px",
sm: 0
},
                            mr: {
 xs: 0,
sm: "16px"
},
                            height: "56px",
                            ...(['uxprimary', 'uxsecondary']?.includes(props?.cta?.variant || "") && {
                              // eslint-disable-next-line eqeqeq
                              ...(props?.cta?.mode == "dark" ?
                                {
                                  backgroundColor: `${colorPalette.turquiose[100]}`,
                                  color: `${colorPalette.black.main}`,
                                  ":hover": {
                                    backgroundColor: `${colorPalette.turquiose.main}`,
                                    color: `${colorPalette.jet.main}`
                                  }
                                } :
                                {
                                  border: isExtended ?
                                    "2px solid black" :
                                    "2px solid white",
                                  backgroundColor: isExtended ?
                                    `${colorPalette.jet.main}` :
                                    "transparent",
                                  color: `${colorPalette.white.main}`,
                                  ":hover": {
                                    backgroundColor: `${colorPalette.white.main}`,
                                    color: `${colorPalette.jet.main}`
                                  }
                                })
                            })
                          }}
                          {...props?.cta}
                          analytics={null}
                          googleAnalyticsData={getAnalyticsAttrs(props?.cta?.ariaLabel || props?.cta?.label, "body", props?.cta?.targeturl)}
                        />
                      )}
                      {props?.optionalCta?.label && (
                        <DtvButton
                          id={`${props?.id}-optionalCta`}
                          label={props?.optionalCta?.label}
                          variant={props?.optionalCta?.variant || "uxprimary"}
                          sx={{
                            mb: {
 xs: "24px",
sm: 0
},
                            mr: {
 xs: 0,
sm: "16px"
},
                            ...(['uxprimary', 'uxsecondary']?.includes(props?.cta?.variant || "") && {
                              // eslint-disable-next-line eqeqeq
                              ...(props?.optionalCta?.mode == "dark" ?
                                {
                                  backgroundColor: props?.optionalCta?.backgroundColor || "transparent",
                                  border: props?.optionalCta?.border || "2px solid white",
                                  color: props?.optionalCta?.color || "#FFFFFF",
                                  height: "56px",
                                  // backgroundColor: `${colorPalette.turquiose[100]}`,
                                  // color: `${colorPalette.black.main}`,
                                  ":hover": {
                                    backgroundColor: `${colorPalette.turquiose.main}`,
                                    color: `${colorPalette.jet.main}`
                                  }
                                } :
                                {
                                  mb: {
 xs: "20px",
sm: 0
},
                                  ml: {
 xs: 0,
sm: "16px"
},
                                  border: isExtended ?
                                    "2px black" :
                                    "2px solid white",
                                  backgroundColor: isExtended ?
                                    "black" :
                                    "transparent",
                                  color: `${colorPalette.white.main}`,
                                  ":hover": {
                                    backgroundColor: `${colorPalette.white.main}`,
                                    color: `${colorPalette.jet.main}`
                                  }
                                })
                            })
                          }
                          }
                          {...props?.optionalCta}
                          analytics={null}
                          googleAnalyticsData={getAnalyticsAttrs(props?.optionalCta?.ariaLabel || props?.optionalCta?.label, "body", props?.optionalCta?.targeturl)}
                        />
                      )}
                    </DtvBox>
                  </DtvGrid>
                )}
                {props?.legalText?.content && (
                  <div role="alert">
                    {props?.legalText?.content && (
                      <DynamicText
                        component={props?.legalText?.component || "div"}
                        content={props?.legalText?.content}
                        dynamicContent={props?.legalText?.dynamicContent}
                        id={`${props?.id}-legalText`}
                        variant={props?.legalText?.variant}
                        sx={{
                          color: props?.legalText?.color || "#FFFFFF",
                          fontWeight: props?.legalText?.fontWeight,
                          fontSize: {
 xs: "12px !important",
xl: "14px !important"
},
                          maxWidth: props?.legalText?.maxWidth || "90%",
                          lineHeight: "15.6px",
                          top: props?.legalText?.top || {
 sm: "26px",
md: "38px",
lg: "49px"
},
                          position: "relative",
                          left: props?.legalText?.left || {
 xs: "20px",
sm: "32px",
md: "100px",
lg: "140px"
},
                          textAlign: props?.legalText?.textAlign || { md: "center" },
                          ...props?.legalText?.sx
                        }}
                      />
                    )}
                  </div>
                )}
              </DtvGrid>
            </DtvGrid>
          </DtvGrid>

        );
      } catch (error) {
        return <ErrorDisplay error={error} />
      }
    };

    return (
      <>
        {showVideo()}
      </>
    )
  } catch (error) {
    return <ErrorDisplay component="Ambient Video" error={error} />;
  }
}
